module.exports = __webpack_public_path__ + "img/calendar_icon.58dd6f4e.png";